import * as React from "react";
import CategoryPanel from "./CategoryPanel";
import Answer from "../model/Answer";

interface PatientAnswersProps {
  answers: Answer[];
}

export default class PatientAnswers extends React.Component<PatientAnswersProps> {
  render() {
    return (
      <div className="patient-expectation">
        <CategoryPanel label={i18n["Page.AssessmentResult.PatientExpectation.Title"]}>
          {this.props.answers.map((answer, i) => (
            <div className="input-group" key={i}>
              <div className="question">{answer.question}</div>
              <div>{answer.value}</div>
            </div>
          ))}
        </CategoryPanel>
      </div>
    );
  }
}
